import classNames from "classnames/bind";
import { GetPageWrapperDataQuery } from "@graphqlTypes";
import { getLinkData } from "@/core/utils";
import { RhLink } from "@components";
import LanguageSelect from "./LanguageSelect/LanguageSelect";

import styles from './DesktopSideNav.module.scss';
const cx = classNames.bind(styles);

type SideNavProps =
  SiteNavigation["navigationSettingsFields"] & {
    languages: GetPageWrapperDataQuery["languages"];
  };

export default function DesktopSideNav(props: SideNavProps) {
  const { membershipLink, donateLink, hostEventLink, languages } = props;
  const memberLinkData = getLinkData(membershipLink);
  const donateLinkData = getLinkData(donateLink);
  const hostEventLinkData = getLinkData(hostEventLink);
  return (
    <div className={cx("desktop-side-nav")}>
      <div className={cx("group")}>
        {memberLinkData && (
          <RhLink className={cx(["tag-l", "side-nav-link"])} href={memberLinkData.url} target={memberLinkData.target} data-gtm-section="nav">
            {memberLinkData.label}
          </RhLink>
        )}
        {donateLinkData && (
          <RhLink className={cx(["tag-l", "side-nav-link"])} href={donateLinkData.url} target={donateLinkData.target} data-gtm-section="nav">
            {donateLinkData.label}
          </RhLink>
        )}
      </div>
      <div className={cx("group")}>
        {hostEventLinkData && (
          <RhLink className={cx(["tag-l", "side-nav-link"])} href={hostEventLinkData.url} target={hostEventLinkData.target} data-gtm-section="nav">
            {hostEventLinkData.label}
          </RhLink>
        )}
        <LanguageSelect languages={languages} />
      </div>
    </div>
  );
}